import { apiMRLocationHistoryMapper } from '@pn/services/api/intel/apiMRLocationHistoryMapper';
import type { ApiMineralRightsLocationHistory } from '@pn/services/api/intel/types';
import { pnApiClient } from '@pn/services/api/pnApiClient';

const requestMineralRightsLocationHistoryByLocation = async (
  location: string
) => {
  const apiMRHeadersWithHistory = await pnApiClient.request<
    ApiMineralRightsLocationHistory[]
  >({
    url: `v2/mineral_rights/${location}/location_history`,
  });

  return apiMRHeadersWithHistory.map((mrHeader) =>
    apiMRLocationHistoryMapper.toDomainMRLocationHistory(mrHeader)
  );
};

export const apiMineralRightsLocationHistoryProvider = {
  getMineralRightsLocationHistory: async (location: string) =>
    requestMineralRightsLocationHistoryByLocation(location),
};
